import { skillGroups, softSkills } from "../data/profile";
import "../styles/Skills.css";

const Skills = () => (
  <div className="page">
    <header className="page-head animate-in">
      <h1 className="page-head__title">
        Skills &amp; <span className="gradient-text">stack</span>
      </h1>
      <p className="lede">
        The platforms and tooling I design, deploy, and operate day to day.
      </p>
    </header>

    {skillGroups.map((group, groupIndex) => (
      <section key={group.name} className="section">
        <h2 className="section-label">{group.name}</h2>
        <div className="skill-grid">
          {group.items.map(({ label, icon, accent }, i) => (
            <div
              key={label}
              className="skill animate-in"
              style={{ animationDelay: `${(groupIndex * 0.05 + i * 0.04).toFixed(2)}s` }}
            >
              <img
                src={icon}
                alt=""
                className={`skill__icon${accent ? ` skill__icon--${accent}` : ""}`}
                loading="lazy"
              />
              <span className="skill__label">{label}</span>
            </div>
          ))}
        </div>
      </section>
    ))}

    <section className="section">
      <h2 className="section-label">How I work</h2>
      <div className="soft-grid">
        {softSkills.map(({ title, body }, i) => (
          <article
            key={title}
            className={`glass-card soft-card animate-in stagger-${Math.min(i + 1, 6)}`}
          >
            <span className="soft-card__index">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="soft-card__title">{title}</h3>
            <p className="soft-card__body">{body}</p>
          </article>
        ))}
      </div>
    </section>
  </div>
);

export default Skills;
